module.exports = __webpack_public_path__ + "static/media/default.c4abffca.svg";